import React from "react";
import { Link } from "react-router-dom";
import { footerNav } from "../data/navigation";
export function Footer() {
  return <footer className="bg-ink text-paper" data-id="element-9" data-mp="3gg0xpz2xhpvj">
      <div className="mx-auto max-w-[1400px] px-5 pb-10 pt-20 md:px-10" data-id="element-10" data-mp="32nulup6t651w">
        <div className="grid gap-14 lg:grid-cols-12" data-id="element-11" data-mp="32pp39tivff18">
          <div className="lg:col-span-5" data-id="element-12" data-mp="36ooa5jo5xlvb">
            <p className="font-display text-4xl leading-tight" data-id="element-13" data-mp="36ppnjusnikg7">Domaine de la Rouquette</p>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-paper/70" data-id="element-14" data-mp="3uftn9r2py01x">
              Producteur et distillateur d'ingrédients naturels pour la cosmétique, au cœur de la Provence
              depuis trois générations.
            </p>
            <address className="mt-8 not-italic text-sm leading-relaxed text-paper/70" data-id="element-15" data-mp="3qd6sbhar3z0i">
              Chemin de la Rouquette, 84400 Apt — France
              <br data-id="element-16" data-mp="29xlz0k1buwgz" />
              <a href="tel:+33490000000" className="hover:text-paper" data-id="element-17" data-mp="2a19sxkaopkw8">+33 4 90 00 00 00</a>
              {" · "}
              <a href="mailto:pro@domainedelarouquette.fr" className="hover:text-paper" data-id="element-18" data-mp="2evxat0b6nh1u">
                pro@domainedelarouquette.fr
              </a>
            </address>
          </div>
          <div className="grid grid-cols-2 gap-10 sm:grid-cols-3 lg:col-span-7" data-id="element-19" data-mp="3gck0h44u4on8">
            {footerNav.map(group => <div key={group.title} data-id="element-20" data-mp="3q8n30b3lmpap">
                <h3 className="text-sm font-medium text-paper" data-id="element-21" data-mp="3q7lr64erdyrx">{group.title}</h3>
                <ul className="mt-5 space-y-3" data-id="element-22" data-mp="828ni7pom7a7">
                  {group.links.map(link => <li key={link.label} data-id="element-23" data-mp="34pa1a0t5yjb">
                      <Link to={link.to} className="text-sm text-paper/65 transition-colors duration-150 hover:text-paper" data-id="element-24" data-mp="33nna8afjnlr">
                        {link.label}
                      </Link>
                    </li>)}
                </ul>
              </div>)}
          </div>
        </div>
        <div className="mt-20 flex flex-col gap-4 border-t border-paper/15 pt-6 text-xs text-paper/55 md:flex-row md:items-center md:justify-between" data-id="element-25" data-mp="qr5i6cozr1sy">
          <p data-id="element-26" data-mp="tw5yw7u65sn9">© 2026 Domaine de la Rouquette. Réservé aux professionnels.</p>
          <div className="flex gap-6" data-id="element-27" data-mp="yto9e2nu4fxd">
            <Link to="/mentions-legales" className="hover:text-paper" data-id="element-28" data-mp="yupku88rj4fm">Mentions légales</Link>
            <Link to="/cgv" className="hover:text-paper" data-id="element-29" data-mp="13sir11a2fyfw">CGV</Link>
            <Link to="/confidentialite" className="hover:text-paper" data-id="element-30" data-mp="18kiwtacthlke">Confidentialité</Link>
          </div>
        </div>
      </div>
    </footer>;
}